export const dispatchingActions = {
  action: 'action',
  amount: 'amount',
  payload: 'payload',
  id: 'id',
  props: 'props',
  values: 'values',
  redirectChallengeData: 'redirectChallengeData'
} as const;
